import { DataCollectionTaskExecutionTypeModule } from "./modules/DataCollectionTaskExecutionTypeModule";
import { GeneralTaskExecutionTypeModule } from "./modules/GeneralTaskExecutionTypeModule";
import { SendEmailTaskExecutionTypeModule } from "./modules/SendEmailTaskExecutionTypeModule";
import { TaskExecutionModuleProps } from "./TaskExecutionModuleProps";

export type TaskExecutionModuleRegistry = Record<
  string,
  React.FC<TaskExecutionModuleProps>
>;
export const defaultRegistry: TaskExecutionModuleRegistry = {
  GeneralTaskExecutionType: GeneralTaskExecutionTypeModule,
  SendEmailTaskExecutionType: SendEmailTaskExecutionTypeModule,
  DataCollectionTaskExecutionType: DataCollectionTaskExecutionTypeModule,
};
